import { TextField } from '@mui/material';
import ReactInputMask from 'react-input-mask';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  disabled?: boolean;
}

export const InputTelephone = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled,
}: Props) => {
  return (
    <ReactInputMask
      disabled={disabled}
      mask='(99) 9999-9999'
      value={value}
      maskChar=' '
      handleBlur={handleBlur}
      onChange={handleChange}
    >
      {/*// @ts-expect-error - .*/}
      {() => (
        <TextField
          size='small'
          disabled={disabled}
          label={label}
          InputLabelProps={{ shrink: true }}
          name={name}
          className={className}
          error={hasError}
          helperText={error}
        />
      )}
    </ReactInputMask>
  );
};
